
import DialogTrigger from './DialogTrigger.js';

class TaoTrigger {
	onExitIntent = ( callback, settings = {} ) => {
		const {
			exitIntent,
			percentDown,
			percentUp,
			delay,
		} = {
			exitIntent: false,
			percentDown: 50,
			percentUp: 10,
			delay: 0,
			...settings,
		};

		// Ensure the function only triggers once.
		let triggered = false;
		const execOnce = () => {
			if ( triggered ) {
				return;
			}

			callback();
			triggered = true;
		};

		// Add Exit Intent Triggers after a timeout.
		new DialogTrigger(
			() => {
				// Add Percent Down Trigger.
				if ( percentDown ) {
					new DialogTrigger(
						() => {
							// After PercentDown - Add PercentUpTrigger.
							if ( percentUp ) {
								new DialogTrigger(
									() => execOnce(),
									{
										// Settings.
										trigger: 'scrollUp',
										percentUp,
									},
								);
							} else {
								// If no percentUp we just show after scrolling down.
								execOnce();
							}
						},
						{
							// Settings.
							trigger: 'scrollDown',
							percentDown,
						},
					);
				}

				// Add Exit Intent Trigger.
				if ( exitIntent ) {
					new DialogTrigger(
						() => execOnce(),
						{
							// Settings.
							trigger: 'exit_intent',
						},
					);
				}
			},
			{
				// Settings.
				trigger: 'timeout',
				timeout: ( delay || 0 ) * 1000,
			},
		);
	};
}

export default new TaoTrigger();
